<div class="flex flex-col -m-6">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <span class="text-lg font-medium">{{ data.assignment.userName }} - {{ data.assignment.sAMAccountName }}</span>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto p-6 pt-0" fuseScrollbar>
        @if (qr()) {
            <img class="flex place-self-center items-center object-scale-down h-96 w-96" src= "{{qr()}}">
        }
        <div class="flex justify-end">
            <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
                {{ 'cancel' | transloco }}
            </button>
            <button class="mr-2" mat-raised-button color="primary" (click)="sendQRToMissionUser()" [matTooltip]="'sendQR' | transloco">
                {{ 'send' | transloco }}
            </button>
        </div>
    </div>
</div>